import {useQuery} from '@github-ui/react-query'
import {isFeatureEnabled} from '@github-ui/feature-flags'
import {verifiedFetchJSON} from '@github-ui/verified-fetch'

interface NoticeDismissalResult {
  dismissed: boolean
}

export function useNoticeDismissal(noticeKey: string) {
  const enabled = isFeatureEnabled('issue_cca_visualization_decoupled_mode')

  return useQuery<NoticeDismissalResult>({
    queryKey: ['notice-dismissal', noticeKey],
    queryFn: async () => {
      const response = await verifiedFetchJSON(`/settings/notice-dismissals/${encodeURIComponent(noticeKey)}`)
      if (!response.ok) {
        throw new Error(`Failed to check notice dismissal: ${response.status}`)
      }
      return (await response.json()) as NoticeDismissalResult
    },
    staleTime: Infinity,
    enabled,
  })
}
